module.exports = __webpack_public_path__ + "static/media/climate.64593121.gif";